'use client';

import { getMessageFallback, onError } from '@/i18n/error';
import { ReactChildren } from '@/types/react';
import { IntlConfig, NextIntlClientProvider } from 'next-intl';
import { FC } from 'react';

// onError and getMessageFallback are not serializable. Therefore they must be defined client-side like this
// See https://next-intl.dev/docs/usage/configuration#nextintlclientprovider
type Props = { locale: IntlConfig['locale'] } & ReactChildren;

const IntlErrorHandlingProvider: FC<Props> = ({ locale, children }) => (
  <NextIntlClientProvider onError={onError} locale={locale} getMessageFallback={getMessageFallback}>
    {children}
  </NextIntlClientProvider>
);

export default IntlErrorHandlingProvider;
